import { CSSProperties, useMemo, useState } from "react";
import { ProgressBar } from "../..";
import { colors, fonts } from "../../../Styles";
import { useTranslation } from "react-i18next";

import { LfLocation } from "../../../Services/Agrisys_GqlDataCaller/LocationFeedingCalls/GQLCalls/getLfStructureCall";

interface PenRemainingToday_Props {
  pen: LfLocation;
  overrides?: {
    baseStyle?: CSSProperties;
  };
  hasHoverEffect?: boolean;
  onClick?: () => void;
  gridArea?: string
}
/**
 * PEN_REMAININGTODAY
 * @param penId Unique identifier for each pen.
 * @param penType Basic, advanced and single. Each renders different content of animal data.
 * @param overrides Style overrides for the pen.
 * @param hasHoverEffect Boolean that, if true, adds a hover effect to the pen.
 * @param onClick Dynamic onClick eventhandler.
 * @returns a pen with varying content of animal data for Freeda Location Feeder systems.
 */
export default function PEN_REMAININGTODAY({pen, hasHoverEffect, onClick, gridArea }: PenRemainingToday_Props) {
  const { t } = useTranslation();
  const [isHovered, setIsHovered] = useState(false);

  const animal = useMemo(() => {
    return pen?.animals ? pen.animals[0] : undefined;
  }, [pen?.animals]) 

  // ConsumptionProgressBar
  const ConsumptionProgressBar: JSX.Element = useMemo(() => {
    const progress = (animal?.consumptions?.[0])
    const progressBarTotal = (progress?.total ?? 0) / 1000;
    const progressBarProgressed = (progress?.progressed ?? 0) / 1000;

    return (
      <ProgressBar
        isPrimaryBar={false}
        animation labelSecondaryBar={animal?.animal_number}
        total={+(progressBarTotal).toFixed(2)}
        progressed={+(progressBarTotal - progressBarProgressed).toFixed(2)}
      />
    );
  }, [animal?.animal_number, animal?.consumptions])

  // Apply hover effect only if hasHoverEffect is true
  const handleMouseEnter = () => {
    if (hasHoverEffect && animal) {
      setIsHovered(true);
    }
  };

  const handleMouseLeave = () => {
    if (hasHoverEffect && animal) {
      setIsHovered(false);
    }
  };

  return (
    <div
      onClick={animal ? onClick : undefined}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      style={{width: "80px", height: "30px", cursor: hasHoverEffect && animal ? "pointer" : "", gridArea: gridArea ?? undefined}}
    >
      <div style={{
        width: "100%",
        height: "100%",
        textAlign: "center",
        alignContent: "center",
        backgroundColor: isHovered ? colors.greyLightPrimary : colors.greyLightSecondary,
        transition: "filter 0.3s",
        color: colors.greyDarkPrimary,
        ...fonts.paragraph,
        ...fonts.fontSize4
      }}>
        {animal
        ? ConsumptionProgressBar
        : <span style={{ opacity: "0.5" }}>
            {t("locationFeederPages.sections.emptyPen", { defaultValue: "Empty pen"})}
          </span>
        }
      </div>
    </div>
  );
}
